function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconYouTube = function SvgIconYouTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.204 7.82c.48.475.636 1.553.636 1.553s.16 1.266.16 2.531v1.187c0 1.266-.16 2.53-.16 2.53s-.157 1.079-.636 1.553c-.548.561-1.156.62-1.5.652l-.103.01C15.362 17.997 12 18 12 18s-4.16-.037-5.44-.157a3.696 3.696 0 0 0-.217-.03c-.406-.047-1.042-.122-1.548-.639-.479-.474-.635-1.552-.635-1.552S4 14.357 4 13.09v-1.187c0-1.265.16-2.531.16-2.531s.156-1.078.635-1.552c.55-.563 1.158-.62 1.502-.652l.102-.01C8.638 7 11.996 7 11.996 7h.008s3.358 0 5.597.158c.03.004.065.007.102.01.343.033.952.09 1.501.653zm-8.857 2.314.001 4.394 4.322-2.19-4.322-2.204z",
    clipRule: "evenodd"
  }));
};
export default SvgIconYouTube;